<template>
  <modal name="modal-add-task" height="auto" :width="580"
         :scrollable="true" :clickToClose="false" @closed="closeModal">
    <div class="modal-head">
      <h4>ADD TASK</h4>
      <a href="javascript:;" class="close" @click="closeModal"></a>
    </div>

    <div class="modal-body">
      <div class="form-row">
        <label class="lb">DATE <span class="text-danger">*</span></label>
        <div class="inputs">
          <date-picker format="DD-MM-YYYY" value-type="YYYY-MM-DD" :input-attr="{name: 'task.due_date'}" v-model="postData.due_date" name="task.due_date" :editable="false" v-validate.disable="{ required: true }"
            input-class="form-control" style="display: block;width: 100%;"></date-picker>
        </div>
        <div class="invalid-feedback">{{ errors.first('task.due_date') }}</div>
      </div>
      <div class="form-row">
        <label class="lb">NAME <span class="text-danger">*</span></label>
        <div class="inputs">
          <textarea-autosize  name="task.name" :min-height="40" :max-height="100"
                           :class="{'form-control': true, 'is-invalid': errors.has('name')}"
                           v-validate.disable="{ required: true }"
                           v-model="postData.name"></textarea-autosize>
        </div>
        <div class="invalid-feedback">{{ errors.first('task.name') }}</div>
      </div>
      <div class="form-row">
        <label class="lb">DESCRIPTION</label>
        <editor name="task.description" :api-key="tinyApiKey" :init="tinyOpts" v-model="postData.description"></editor>
      </div>
    </div>

    <div class="modal-foot">
      <div class="btns btns-2">
        <beat-loader v-if="state == 'saving'"></beat-loader>
        <template v-else>
          <button type="button" class="btn btn-outline-black" @click="doAdd">Add</button>
          <button type="button" class="btn btn-outline-gray" @click="closeModal">Cancel</button>
        </template>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import BeatLoader from 'vue-spinner/src/BeatLoader'
import DatePicker from 'vue2-datepicker';
import Editor from '@tinymce/tinymce-vue'
import ServiceTask from '@/services/task'

export default {
  components: {
    DatePicker,
    BeatLoader,
    Editor
  },
  data () {
    return {
      state: '',
      dateAttr: {
        name: 'task.due_date'
      },
      postData: false,
    }
  },
  props: ['value'],
  watch: {
    value ( newVal ) {
      let self = this;
      if ( newVal ) {
        self.$modal.show('modal-add-task', {});
      }
    }
  },
  computed: {
    ...mapGetters(['JOB']),
    ...mapState({
      tinyApiKey: state => state.option.tinyApiKey,
      tinyOpts: state => state.option.tinyOpts
    }),
  },
  created () {},
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;
      self.resetForm();
    },
    resetForm () {
      let self = this;
      self.postData = {
        due_date: '',
        name: '',
        description: '',
        job_id: self.JOB.id,
        client_id: self.JOB.client_id
      };
    },
    doAdd () {
      let self = this;
      if (self.state == 'saving') {
        return;
      }
      self.$validator.validateAll()
        .then(ok => {
          if ( ok ) {
            self.state = 'saving';
            ServiceTask.create(self.postData, job => {
              self.state = '';
              self.$notify({
                type: 'success',
                text: 'Task <strong>' + job.name + '</strong> created'
              });
              self.resetForm();
              self.$emit('task-created', job);
              self.closeModal();
            }, () => {
              self.state = '';
            });
          }
        });
    },
    closeModal () {
      this.$modal.hide('modal-add-task');
      this.$emit('task-modal-close');
    }
  }
}
</script>
